import { createSelector } from 'reselect';

const componentsStateSelector = state => state.components;
const componentSelector = name =>
  createSelector(componentsStateSelector, components => components[name]);

export default componentSelector;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/selectors/component.js